import styles from './EditTour.module.css';
import { Route, Switch, useParams, useRouteMatch } from "react-router-dom";
import EditTourSidebar from './../../components/edit-tour-sidebar/EditTourSidebar';
import EditTourInfo from './../../components/edit-tour-info/EditTourInfo';
import EditScene from './../edit-scene/EditScene';
import { useAppStore } from '../../hooks/store/useAppStore';
import { getTourSelector } from '../../hooks/store/getters';
import { setTourObjSelector } from '../../hooks/store/setters';
import { useMemo, useEffect } from 'react';
import { getTour } from "../../services/TourService";
import { setLoaderSelector } from '../../hooks/store/setters';
import { setAlertMessageSelector } from '../../hooks/store/setters';
import { setTourNewSceneErrorSelector, setTourActiveSceneIndexSelector } from './../../hooks/store/setters';
import { setTourSceneNewHotspotErrorSelector } from '../../hooks/store/setters';
import { hotspotErrorInitialState } from "../../hooks/store/Types";
import { setTourErrorActiveSceneIndexSelector } from '../../hooks/store/setters';
const EditTour = () => {
    
    const { id } = useParams();
    const { path } = useRouteMatch();
    
    const tourId = useMemo(() => id, [id])
    
    const currentTour = useAppStore(getTourSelector(tourId));
    const setTourObj = useAppStore(setTourObjSelector);
    const setLoader = useAppStore(setLoaderSelector);
    const setAlertMessage =useAppStore(setAlertMessageSelector);
    const setTourNewSceneError = useAppStore(setTourNewSceneErrorSelector);
    const setTourActiveSceneIndex = useAppStore(setTourActiveSceneIndexSelector);
    const setTourSceneNewHotspotError = useAppStore(setTourSceneNewHotspotErrorSelector);
    const setTourErrorActiveSceneIndex = useAppStore(setTourErrorActiveSceneIndexSelector);
    
    useEffect( () => {         
        if(currentTour) { 
            currentTour.scenes.map((s ,idx) => {
                setTourErrorActiveSceneIndex(idx);
                setTourNewSceneError();
                s.hotspots.map((h,index) => {
                    setTourSceneNewHotspotError({...hotspotErrorInitialState});
                    return h;
                })
                return s;
            })
            
            setTourObj(currentTour);
        } else { 
            setLoader("Loading....");   
            const getTourObj = async (id) => {
                try {       
                    const tour = await getTour(id);
                    tour.scenes.map((s ,idx) => {
                        setTourErrorActiveSceneIndex(idx);
                        setTourNewSceneError();
                        s.hotspots.map(h => {
                            setTourSceneNewHotspotError({...hotspotErrorInitialState});
                            return h;
                        })
                        return s;
                    })

                    setTourObj(tour);      
                } catch (error) {
                    setAlertMessage("Error while loading tour");
                }  
            }
            setLoader("");            
            getTourObj(id);
        }
        // eslint-disable-next-line       
    }, [currentTour, setTourObj, id ])

    useEffect(() => {
        return () => {
            setTourActiveSceneIndex(null);
        }

    },[setTourActiveSceneIndex])

    
    
    return (
        <div className={styles.editTourContainer}>
            <EditTourSidebar />
            
            <section className={styles.editTourBody}>
                <Switch>
                    <Route path={`${path}/tour-info`} component={EditTourInfo} />
                    <Route path={`${path}/create-scene`} component={EditScene} />
                </Switch>
            </section>
        </div>
    );
};

export default EditTour;